<template>
  <div class="banner">
    <el-col :span="24" class="action-bar">
      <!-- <span style="color:#888888;">轮播图管理:</span> -->
      <el-button type="primary" size="medium" @click="addBtnReset" style="margin: 0 20px;">新增</el-button>
    </el-col>

    <!--列表-->
    <el-table :data="sectionList" highlight-current-row class="el-table-style">
      <el-table-column type="selection" min-width="55">
      </el-table-column>
      <el-table-column type="index" min-width="60">
      </el-table-column>
      <el-table-column label="展示图" min-width="60" sortable>
        <template slot-scope="scope">
          <img :src="scope.row.img_url" min-width="60" height="60"/>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称" min-width="60">
      </el-table-column>
      <el-table-column prop="link_url" label="链接" min-width="100" sortable>
        <template slot-scope="scope">
          <div>
            <el-button type="primary"
                       v-clipboard:copy="scope.row.link_url"
                       v-clipboard:success="onCopy"
                       size="mini"
                       v-clipboard:error="onError">复制链接</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="link_type_name" label="栏目类型" min-width="60"/>
      <el-table-column prop="sort" label="排序" min-width="100" sortable>
      </el-table-column>
      <el-table-column label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button v-if="scope.row.link_type==3" type="primary" size="mini" @click="tieUnit(scope.row.id)">绑定单位</el-button>
          <el-button type="primary" size="mini" @click="getSectionClassifyDetail(scope.row.id)">编辑</el-button>
          <el-button type="danger" class="danger-btn" size="mini" @click="delSectionClassify(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24" class="footer-bar">
      <!-- <div class="batch"><el-button size="medium ">批量删除</el-button></div> -->
      <div class="page-code">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageTotal"
          :page-size="limit"
          :current-page="page"
          @current-change="getSectionClassifyList"
        >
        </el-pagination>
      </div>
    </el-col>

    <!-- 新增 -->
    <el-dialog title="新增栏目" :visible.sync="addFormVisible" width="40%">
      <el-form label-width="80px">
        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            name="photo"
            :action="UPLOAD_IMG"
            :show-file-list="false"
            :on-success="addUploadSuccess"
          >
            <img v-if="addForm.imgUrl" :src="addForm.imgUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="addForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="栏目类型">
          <el-select v-model="addForm.link_type" clearable placeholder="请选择">
            <el-option
              v-for="item in columnOption"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接" v-if="editForm.link_type!=2&&editForm.link_type!=3">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="addForm.link_url"
            :fetch-suggestions="querySearch"
            placeholder="请输入内容"
            @select="handleSelect">
            <i
              class="el-icon-edit el-input__icon"
              slot="suffix"
              @click="handleIconClick">
            </i>
            <template slot-scope="{ item }">
              <div class="name">{{ item.name }}</div>
              <span class="addr">{{ item.link_url }}</span>
            </template>
          </el-autocomplete>
          <!--					<el-input v-model="addForm.link_url" auto-complete="off" clearable></el-input>-->
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="addForm.sort" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addCancelBtn">取消</el-button>
        <el-button type="primary" @click="addSubmitBtn">提交</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog title="编辑栏目" :visible.sync="editFormVisible" width="40%">
      <el-form label-width="80px">
        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            name="photo"
            :action="UPLOAD_IMG"
            :show-file-list="false"
            :on-success="editUploadSuccess"
          >
            <img v-if="editForm.imgUrl" :src="editForm.imgUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="editForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="栏目类型">
          <el-select v-model="editForm.link_type" clearable placeholder="请选择">
            <el-option
              v-for="item in columnOption"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接" v-if="editForm.link_type!=2&&editForm.link_type!=3">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="editForm.link_url"
            :fetch-suggestions="querySearch"
            placeholder="请输入内容"
            @select="handleSelects">
            <i
              class="el-icon-edit el-input__icon"
              slot="suffix"
              @click="handleIconClick">
            </i>
            <template slot-scope="{ item }">
              <div class="name">{{ item.name }}</div>
              <span class="addr">{{ item.link_url }}</span>
            </template>
          </el-autocomplete>
          <!--					<el-input v-model="editForm.link_url" auto-complete="off"></el-input>-->
        </el-form-item>

        <el-form-item label="排序">
          <el-input v-model="editForm.sort" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editCancelBtn">取消</el-button>
        <el-button type="primary" @click="editSubmitBtn">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {UPLOAD_IMG} from "@/api/index.js";

export default {
  data(){
    return{
      UPLOAD_IMG,
      addFormVisible: false,//新增界面是否显示
      editFormVisible: false,//编辑界面是否显示
      addImageUrl:'',
      pageTotal:0,
      pid :'',
      limit:5,
      page: 1,
      //新增界面数据
      addForm: {
        img_id:'',
        link_url:'',
        imgUrl:'',
        sort: '',
        name: '',
        level: 2,
        link_type:0,
        pid:''
      },
      //编辑界面数据
      editForm: {
        id:'',
        img_id:'',
        link_url:'',
        imgUrl:'',
        sort: '',
        name: '',
        level: '',
        link_type:0,
        pid:''
      },
      sectionList:[],
      sectionUrl: [],
      columnOption:[
        {
          id:0,
          name:'页面路径'
        },
        {
          id:1,
          name:'公众号推文'
        },
        // {
        //   id:2,
        //   name:'自定义栏目'
        // },
        {
          id:3,
          name:'单位库'
        },
      ]
    }
  },
  mounted(){
    this.pid = this.$route.query.id;
    this.addForm.pid=this.pid
    this.editForm.pid=this.pid
    this.getSectionClassifyList();
    this.getSectionUrl();
  },
  methods:{
    tieUnit(id){
      this.$router.push({
        path:'unit_list',
        query:{id}
      })
    },
    //获取栏目链接
    async getSectionUrl(){
      const res = await this.$api.getSectionUrl();
      if (res.data.level == 'success'){
        this.sectionUrl = res.data.data
      }
    },
    onCopy(e){
      this.$message({
        type:'success',
        message:'复制成功'
      })
    },
    onError(erro){
      this.$message({
        type:'error',
        message:'复制失败'
      })
    },
    //新增上传图片成功回调
    addUploadSuccess(res, file) {
      if(res.data){
        this.addForm.imgUrl = res.data.img_url;
        this.addForm.img_id = res.data.id;
      }
    },
    //编辑上传图片成功回调
    editUploadSuccess(res, file) {
      if(res.data){
        this.editForm.imgUrl = res.data.img_url;
        this.editForm.img_id = res.data.id;
      }
    },
    //新增取消按钮
    addCancelBtn(){
      this.addForm = {
        img_id:'',
        link_url:'',
        imgUrl:'',
        sort: '',
        name: '',
        level: 2,
        link_type:0,
      };
      this.addFormVisible = false;
    },
    //编辑取消按钮
    editCancelBtn(){
      this.editForm={
        id:'',
        img_id:'',
        link_url:'',
        imgUrl:'',
        sort: '',
        name: '',
        level: '',
        link_type:0
      }
      this.editFormVisible = false;
    },
    //新增按钮重置表单
    addBtnReset(){
      this.addForm = {
        img_id:'',
        link_url:'',
        imgUrl:'',
        sort: '',
        name: '',
        level: 2,
        link_type:0
      };
      this.addFormVisible = true;
    },
    //获取栏目列表
    async getSectionClassifyList(page){
      this.page = page || this.page;
      let params = {
        limit:this.limit,
        page: this.page,
        pid:this.pid
      }
      const res = await this.$api.getSectionClassifyList(params);
      if(res.data.level=='success'){
        let list = res.data.data;
        this.sectionList = list;
        this.pageTotal = res.data.page_info.total
      }else{
        this.$message({
          message: res.data.message,
          type: 'warning'
        });
      }
    },
    //编辑获取栏目信息
    async getSectionClassifyDetail(id){
      const params = {
        id: id
      }
      const res = await this.$api.getSectionClassifyDetail(params);
      if(res.data.level=='success'){
        this.editForm={
          id:res.data.data.id,
          img_id:res.data.data.img_id,
          link_url:res.data.data.link_url,
          imgUrl: res.data.data.img_url,
          sort: res.data.data.sort,
          name: res.data.data.name,
          level: res.data.data.level,
          link_type:res.data.data.link_type.valueOf(),
          pid: res.data.data.pid,
        }
        this.editFormVisible = true;
      }else{
        this.$message({
          message: res.data.message,
          type: 'warning'
        });
      }
      console.log(this.editForm,'this.editForm')
    },
    //编辑提交按钮
    async editSubmitBtn(){
      let levelShow=this.sectionUrl.some(item=>item.link_url===this.editForm.link_url)
      if(!levelShow){
        this.editForm.level=2
      }
      this.editForm.pid=this.pid
      const res = await this.$api.setSectionClassify(this.editForm);
      if(res.data.level=='success'){
        this.$message({
          message: '修改成功',
          type: 'success'
        });
        this.editCancelBtn();
        this.getSectionClassifyList();
      }else{
        this.$message({
          message: res.data.message,
          type: 'warning'
        });
      }
    },
    //新增提交按钮
    async addSubmitBtn(){
      let levelShow=this.sectionUrl.some(item=>item.link_url===this.addForm.link_url)
      if(!levelShow){
        this.addForm.level=2
      }
    this.addForm.pid=this.pid
      const res = await this.$api.setSectionClassify(this.addForm);
      if(res.data.level=='success'){
        this.$message({
          message: '修改成功',
          type: 'success'
        });
        this.addCancelBtn();
        this.getSectionClassifyList();
      }else{
        this.$message({
          message: res.data.message,
          type: 'warning'
        });
      }
    },
    //删除轮播图
    async delSectionClassify(id){
      const params = {
        id:id,
      }
      //删除
      const judge= this.$confirm('删除该栏目?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        let res = await this.$api.delSectionClassify(params)
        if(res.data.level=='success'){
          this.getSectionClassifyList();
          this.$message({
            type: 'success',
            message: res.data.message
          });
        }else{
          this.$message({
            type: 'error',
            message: res.data.message
          });
        }
      }).catch(() => {
      });
    },
    querySearch(queryString, cb) {
      var restaurants = this.sectionUrl;
      // var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(restaurants);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.id.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.addForm.level = item.level;
      this.addForm.link_url = item.link_url
    },
    handleSelects(item){
      this.editForm.level = item.level;
      this.editForm.link_url = item.link_url
    },
    handleIconClick(ev) {
      // console.log(ev);
    }
  }
}
</script>
<style lang='scss' scoped>
.banner{
  .action-bar{
    background-color: #f2f2f2;
    height: 60px;
    margin: 10px 0px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding-left: 20px;
    .action-bar-input{
      width: 250px;
      margin-right: 14px;
    }
  }
  .el-table-style{
    width: 100%;
    border: 1px solid #f2f2f2;
  }
  .footer-bar{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f2f2f2;
    padding: 8px;
    margin: 10px 0px;
    box-sizing: border-box;
  }
  .dialog-footer{
    text-align: center;
  }
}

</style>

<style>
.el-autocomplete{
  width: 80% !important;
}
.el-pagination.is-background .el-pager li,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .btn-next
{
  background-color: #fff;
  border: 1px solid #f1f1f1;
  margin: 0;
}
.member .el-dialog__body{overflow: auto;}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/pages/system/child_banner_subject/components/subject.vue